import { Injectable } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { LogoutStateHandlerService } from './logout-state-handler.service';
import { Location } from '@angular/common';
import ArabicsObject from '../misc/data/arabics.json';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private readonly getCacheDurations: { [key: string]: number } = {
    'ou/ouChilds?removeInactive=true': 10 * 60 * 1000,
  };
  private readonly pendingGetRequests = new Map<string, Promise<any>>();

  constructor(private router: Router,
    private http: HttpClient,
    private loginStateHandler: LogoutStateHandlerService,
    private location: Location
  ) { }

  private getCacheKey(url: string): string {
    return `data-service:get:${GlobalConstants.apiURL}${url}`;
  }

  private getCacheDuration(url: string): number | null {
    return this.getCacheDurations[url] ?? null;
  }

  private getCachedGetResponse(url: string): any | null {
    const cacheKey = this.getCacheKey(url);
    const cachedValue = localStorage.getItem(cacheKey);

    if (!cachedValue) {
      return null;
    }

    try {
      const parsedCache: CachedGetResponse = JSON.parse(cachedValue);

      if (parsedCache.expiresAt <= Date.now()) {
        localStorage.removeItem(cacheKey);
        return null;
      }

      return parsedCache.response;
    } catch (error) {
      localStorage.removeItem(cacheKey);
      return null;
    }
  }

  private setCachedGetResponse(url: string, response: any, cacheDuration: number): void {
    const cacheKey = this.getCacheKey(url);
    const cacheValue: CachedGetResponse = {
      expiresAt: Date.now() + cacheDuration,
      response,
    };

    localStorage.setItem(cacheKey, JSON.stringify(cacheValue));
  }

  private buildGetRequest(URL: string, headers: any): Promise<any> {
    return this.http
      .get(URL, { headers: headers }).pipe(map((response: any) => {
        console.log('RESPONSE', response);
        return {
          error: !response.success,
          msg: this.convertMsg(response?.message),
          data: response.data,
          statusCode: !response.success ? response.statusCode : 200
        }
      }))
      .toPromise();
  }

  postData = async (
    url: string,
    data: any,
    method = 'POST',
    formData = false
  ) => {
    try {
      let URL: string = `${GlobalConstants.apiURL}${url}`;
      //creating headers
      const headers: any = formData
        ? {}
        : {
          'Content-Type': 'application/json',
        };

      var context: any =
        method == 'POST'
          ? await this.http
            .post<any>(URL, data, { headers: headers }).pipe(map((response: any) => {
              return {
                error: !response.success,
                msg: this.convertMsg(response?.message),
                data: response.data,
                statusCode: !response.success ? response.statusCode : 200
              }
            }))
            .toPromise()
          : await this.http
            .put<any>(URL, data, { headers: headers }).pipe(map((response: any) => {
              return {
                error: !response.success,
                msg: this.convertMsg(response?.message),
                data: response.data,
                statusCode: !response.success ? response.statusCode : 200
              }
            }))
            .toPromise();

      return context;
    } catch (error: any) {
      return this.handleError(error);
    }
  };

  handleError(error: any) {
    console.log('ERROR', error)
    let { statusCode, message } = error.error
    if (statusCode == 401) {
      this.storeCurrentStateUrl();
    }
    const context = {
      error: true,
      msg: this.convertMsg(message),
      data: null,
    };
    return context;
  }

  getData = async (url: string, method = 'GET') => {
    try {
      let URL: string = GlobalConstants.apiURL + url;
      const headers: any = {
        'Content-Type': 'application/json',
      };

      const cacheDuration = this.getCacheDuration(url);

      if (cacheDuration) {
        const cachedResponse = this.getCachedGetResponse(url);
        if (cachedResponse) {
          return cachedResponse;
        }

        const pendingRequest = this.pendingGetRequests.get(url);
        if (pendingRequest) {
          return pendingRequest;
        }
      }

      const requestPromise = this.buildGetRequest(URL, headers);

      if (cacheDuration) {
        this.pendingGetRequests.set(url, requestPromise);
      }

      var context: any = await requestPromise;

      if (context.statusCode == 401) {
        localStorage.clear();
        this.router.navigate(['/login']);
      }

      if (cacheDuration && !context?.error) {
        this.setCachedGetResponse(url, context, cacheDuration);
      }

      return context;
    } catch (error: any) {
      return this.handleError(error);
    } finally {
      this.pendingGetRequests.delete(url);
    }
  };

  deleteData = async (url: string, method = 'DELETE') => {
    try {
      let URL: string = `${GlobalConstants.apiURL}${url}`;
      //creating headers
      const headers: any = {
        'Content-Type': 'application/json',
      };

      var context: any = await this.http
        .delete<any>(URL, { headers: headers }).pipe(map((response: any) => {
          return {
            error: false,
            msg: this.convertMsg(response?.msg),
            data: response,
          }
        }))
        .toPromise();

      return context;
    } catch (error: any) {
      this.handleError(error);
    }
  };


  public storeCurrentStateUrl() {
    console.log('ERROR TEXT')
    if (!this.loginStateHandler.loginStateUrl) {
      this.loginStateHandler.loginStateUrl = this.location.path();
    }
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  public blogRequest(url: string, body: any): Observable<Blob> {

    let URL: string = `${GlobalConstants.apiURL}${url}`;

    return this.http.post(URL, body, { responseType: 'blob' })
  }


  

  // postData = async (url: string, data:any, method = "POST", formData = false) => {
  //   try {
  //     let URL: string = `${GlobalConstants.apiURL}${url}`;

  //     let token: string | null =  localStorage.getItem("token");

  //     // if (token!=null || token!=undefined) token= JSON.parse(token);
  //      const response = await fetch(URL, {
  //       method: method,
  //       body: formData ? data : JSON.stringify(data),
  //       // body: data,
  //       headers: formData
  //         ? {
  //           "Authorization": `baarer ${token}`
  //         }
  //         : {
  //             "Content-Type": "application/json",
  //             "Authorization": `baarer ${token}`
  //           },
  //     });

  //     if (!response.ok) {
  //       const errorText = await response.statusText;
  //       if(errorText == "jwt expired" || errorText == "jwt malformed") this.router.navigate(["/login"]);
  //       const context = { error: true, msg: this.convertMsg(errorText), data: null };
  //       return context;
  //     }
  //     const result = await response.json();
  //     const context = {
  //       error: false,
  //       msg: this.convertMsg(result.msg),
  //       data: result,
  //     };
  //     return context;
  //   } catch (error) {
  //     const context = { error: true, msg: this.convertMsg(error), data: null };
  //     return context;
  //   }
  // };

  // getData = async (url: string, method = "GET") => {
  //   try {
  //     let URL: string = `${GlobalConstants.apiURL}${url}`;

  //      //console.log("url:", URL )

  //     let token: string | null =  localStorage.getItem("token");
  //      const response = await fetch(URL, {
  //       method: method,
  //       headers: {
  //             "Content-Type": "application/json",
  //             "Authorization": `baarer ${token}`
  //           },
  //     });

  //     if (!response.ok && response.status !== 200) {
  //       const errorText = response.statusText;
  //       if(errorText == "jwt expired" || errorText == "jwt malformed") this.router.navigate(["/login"]);
  //       const context = { error: true, msg: this.convertMsg(errorText), data: null };
  //       return context;
  //     }

  //     const result = await response.json();

  //     const context = {
  //       error: false,
  //       msg: this.convertMsg(result.msg),
  //       data: result.data,
  //     };
  //     return context;

  //   } catch (error) {
  //     const context = { error: true, msg: this.convertMsg(error), data: null };
  //     return context;
  //   }
  // };

  // deleteData = async (url: string, method = "DELETE") => {
  //   try {
  //     let URL: string = `${GlobalConstants.apiURL}${url}`;

  //      //console.log("url:", URL )

  //     let token: string | null =  localStorage.getItem("token");
  //      const response = await fetch(URL, {
  //       method: method,
  //       headers: {
  //             "Content-Type": "application/json",
  //             "Authorization": `baarer ${token}`
  //           },
  //     });

  //     if (!response.ok && response.status !== 200) {
  //       const errorText = response.statusText;
  //       if(errorText == "jwt expired" || errorText == "jwt malformed") this.router.navigate(["/login"]);
  //       const context : Context = { error: true, msg: this.convertMsg(errorText), data: null };
  //       return context;
  //     }

  //     const result = await response.json();

  //     const context = {
  //       error: false,
  //       msg: this.convertMsg(result.msg),
  //       data: result.data,
  //     };
  //     return context;

  //   } catch (error) {
  //     const context = { error: true, msg: this.convertMsg(error), data: null };
  //     return context;
  //   }
  // };

  convertMsg = (msg: any) => {
    const key = typeof msg === 'string' ? msg.trim() : msg;
    switch (key) {
      case 'Partial Service Outage':
        return 'عذراً، فشل الطلب، الرجاء معاودة المحاولة في وقت لاحق ';

      case 'password and conform password doesnot matchs':
        return 'كلمتا المرور غير متطابقتان';

      case 'Invalid Password or Email':
        return 'البريد الإلكتروني أو كلمة المرور التي أدخلتها غير صحيحة';

      case `User Doesn't Exist`:
        return 'هذا المستخدم غير موجود. الرجاء التسجيل ';

      case 'Invalid Email':
        return 'البريد الإلكتروني الذي أدخلته غير مسجل، الرجاء التسجيل ';

      case 'Service Unavailable':
        return 'تعذر الاتصال بالخادم الوكيل. يرجى التحقق من أتصالك بالانترنت ومعاودة المحاولة';

      case 'User Registered Successfully kindly Check Your Mail to get your credentials':
        return 'تم إنشاء المستخدم بنجاح وتم إرسال معلومات تسجيل الدخول عبر البريد الإلكتروني';

      case 'User Registered Successfully we will send you a mail after the approval':
        return 'شكراً لك على التسجيل في بوابة المعرفة، سنرسل لك معلومات تسجيل الدخول بمجرد موافقة الإدارة على طلبك';

      case 'New passsword had been sended to your mail':
        return 'معلومات تسجيل الدخول تم إرسالها إلى بريدك الإلكتروني';

      case 'TypeError: Failed to fetch':
        return 'تعذر الاتصال بالخادم الوكيل. يرجى التحقق من أتصالك بالانترنت ومعاودة المحاولة.';

      case 'Updated Successfully':
        return 'تم تحديث المعلومات بنجاح';

      case 'Invalid password Change request':
        return 'عذراً، فشل طلب تغيير كلمة المرور، الرجاء معاودة المحاولة في وقت لاحق';

      case '"email" must be a valid email':
        return 'البريد الإلكتروني الذي أدخلته غير صالح، يرجى التحقق من عنوان بريدك الإلكتروني وإعادة المحاولة';

      case 'User Already Exist':
        return 'هذا البريد الإلكتروني مسجل على المنصة، جرب بريد إلكتروني أخر .';

      case 'User Activated Successfully':
      case 'User activated successfully':
        return 'تم تفعيل المستخدم بنجاح';

      case 'User deactivated successfully':
        return 'تم إلغاء تفعيل المستخدم بنجاح';

      case 'User Not Activated':
        return 'فشل التفعيل';

      case 'Data update request rejected successfully':
        return 'تم رفض طلب التحديث بنجاح';

      case 'Data update request approved successfully':
        return 'تم قبول طلب التحديث بنجاح';

      case 'This request has already been responded to by a content manager.':
        return 'تم الرد على الطلب من قبل مدير المحتوى';

      case 'Password updated Successfully':
        return 'تم تحديث كلمة المرور بنجاح';

      case 'Password not updated':
        return 'فشل تحديث كلمة المرور';

      case '"password" is not allowed to be empty':
        return 'يجب عليك إدخال كلمة المرور';

      case '"email" is not allowed to be empty':
        return 'يجب عليك إدخال البريد الإلكتروني';
      case 'User not activated, please contact administrator':
        return '.المستخدم غير مصرح له. يرجى التواصل مع الإدارة للحصول على مزيد من المعلومات ';
      case 'Invalid OTP':
        return '.كلمة المرور التي أدخلتها غير صالحة ';

      case 'Knowledge library created successfully':
        return 'تم إنشاء مكتبة المعرفة بنجاح';

      case 'Knowledge library updated successfully':
        return 'تم تحديث مكتبة المعرفة بنجاح';

      case 'Knowledge library deleted successfully':
        return 'تم حذف مكتبة المعرفة بنجاح';

      case 'Failed to update Knowledge library':
        return 'فشل تحديث مكتبة المعرفة';

      case 'Failed to delete Knowledge library':
        return 'فشل حذف مكتبة المعرفة';

      case 'Knowledge library category created successfully':
        return 'تم إنشاء تصنيف مكتبة المعرفة بنجاح';

      case 'Knowledge library category updated successfully':
        return 'تم تحديث تصنيف مكتبة المعرفة بنجاح';

      case 'Failed to update Knowledge library category':
        return 'فشل تحديث تصنيف مكتبة المعرفة';

      default: {
        if (typeof key === 'string') {
          const fromArabics = (ArabicsObject as Record<string, string>)[key];
          if (fromArabics) {
            return fromArabics;
          }
        }
        return key;
      }
    }
  };
}

interface Context {
  error: boolean;
  msg: string;
  data: any;
}

interface CachedGetResponse {
  expiresAt: number;
  response: Context;
}
